import(/* webpackMode: "eager" */ "/work/src/app/error.tsx");
